import { SetDefaultData, FetchSettingsRequest } from './settings.actions'
import { NavigationStart, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent extends FormTrait implements OnInit, OnDestroy {
  public tab: string
  private router$: Subscription

  constructor(public router: Router, public store: Store<any>) {
    super()
  }

  ngOnInit() {
    let split = this.router.url.split('/')
    this.tab = split[split.length - 1]
    this.store.dispatch<any>(new SetDefaultData('settings'))

    this.router$ = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(({ url }: any) => {
        split = url.split('/')
        this.tab = split[split.length - 1]
      })

    // this.store.dispatch<any>(
    //   new FetchFormsRequest({
    //     filter: {},
    //     itemsPerPage: 1000,
    //     page: 0,
    //     order: {},
    //   }),
    // )
  }

  ngOnDestroy() {
    this.router$.unsubscribe()
  }
}
